import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/plans/list',
    method: 'get',
    params: params
  })
}

export function listAll(params) {
  return request({
    url: '/plans/listAll',
    method: 'get',
    params: params
  })
}

export function getRecruitPlans(params) {
  return request({
    url: '/plans/getRecruitPlans',
    method: 'get',
    params: params
  })
}


export function planList(params) {
  return request({
    url: '/pubplan/planList',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/recruitPlans.js